import axios from 'axios';

const baseURL = 'https://bhevin.fly.dev/api/v1';

const callApi = (method, url, params, data, isAuth) => {
  const properties = {
    baseURL,
    method,
    url,
    params,
    data,
  };

  if (isAuth) {
    properties.headers = {
      Authorization: `Bearer ${isAuth || ''}`
    }
  };

  return axios(properties);
}

export const registrationApi = (data) => (
  callApi('post', '/registration', {}, data)
);

export const loginApi = (data) => (
  callApi('post', '/login', {}, data)
);

export const removeAccountApi = (data) => (
  callApi('delete', '/delete', {}, data)
);

export const clothesInquiryApi = () => (
  callApi('get', '/clothes', {}, {})
);

export const clothesEntityApi = (params, isAuth) => (
  callApi('get', `/clothes/${params}`, {}, {}, isAuth)
);

export const clothesInsertApi = (data, isAuth) => (
  callApi('post', '/clothes/insert', {}, data, isAuth)
);

export const clothesUpdateApi = (params, data, isAuth) => (
  callApi('put', `/clothes/update/${params}`, {}, data, isAuth)
);

export const clothesDeleteApi = (params, isAuth) => (
  callApi('delete', `/clothes/delete/${params}`, {}, {}, isAuth)
);